module.exports = __webpack_public_path__ + "static/media/wechatQrcode.c3ee77a3.jpg";